import { useNavigate } from "react-router-dom";
const PrivateRoute = ({ auth, component }) => {
  const navigate = useNavigate();
  return auth ? component : navigate("/");
};
export default PrivateRoute;
